export const DATE_RANGE_FILTER_LABEL = 'Date Range';

// ui-common defaults maxVisibleChips to 4, but the pinned date-range chip consumes
// bar width — show overflow one chip earlier to avoid breaking the layout.
export const PINNED_DATE_RANGE_MAX_VISIBLE_CHIPS = 3;
